import React from 'react';
import styled, { css, keyframes } from 'styled-components';
import media from '../../../constants/media';

const spin = keyframes`
	0% {
		transform: rotate(0);
		animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
	}
	50% {
		transform: rotate(180deg);
		animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
	}
	100% {
		transform: rotate(360deg);
	}
`;

export const StyledButton = styled.button`
	position: relative;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	flex: auto 0 0;
	height: 5rem;
	padding: 0 5rem;
	color: ${({ theme }) => theme.colors.primary};
	background-color: #fff;
	font-family: ${({ theme }) => theme.fonts.ArimoMedium};
	font-size: 1.6rem;
	border-radius: 0;
	border: 1px solid ${({ theme }) => theme.colors.borderColor};
	white-space: nowrap;
	text-overflow: ellipsis;
	cursor: pointer;
	transition-property: color, background-color, background, border, transform, opacity;
	transition-duration: 200ms;
	margin-right: ${({ marginRight }) => marginRight || '0'};
	overflow: hidden;
	&:hover {
		background: ${({ theme }) => theme.colors.grayTransparent};
		color: ${({ theme }) => theme.colors.primary};
		${({ primary }) =>
			primary &&
			css`
				background: ${({ theme }) => theme.colors.primaryDark};
				color: ${({ theme }) => theme.colors.white};
			`}
	}

	${({ darkText, theme }) =>
		darkText &&
		css`
			color: ${theme.colors.black};
		`};

	${({ primary, theme }) =>
		primary &&
		css`
			background-color: ${theme.colors.primary};
			color: #fff;
		`};

	${({ secondary, theme }) =>
		secondary &&
		css`
			background-color: ${theme.colors.secondary};
			color: #fff;
		`};

	${({ flat }) =>
		flat &&
		css`
			border: none;
			background-color: transparent;
		`};

	${({ wide }) =>
		wide &&
		css`
			padding: 0 8rem;
		`};

	${({ mobileBlock }) =>
		mobileBlock &&
		css`
			${media.mobileOnly`
                width: 100%
            `}
		`};

	${({ disabled }) =>
		disabled &&
		css`
			pointer-events: none;
			opacity: 0.5;
		`};

	${({ isLoading, primary, theme }) =>
		isLoading &&
		css`
			opacity: 0.5;
			pointer-events: none;

			&:after {
				content: '';
				width: 1rem;
				height: 1rem;
				margin-left: 1rem;
				animation: ${spin} 1000ms infinite;
				background: center center no-repeat;
				background-size: cover;
				border-radius: 50%;
				border-style: solid;
				border-width: 0.15rem;
				border-color: ${primary
					? '#fff #fff #fff transparent'
					: `${theme.colors.primary} ${theme.colors.primary} ${theme.colors.primary} transparent`};
			}
		`}
	${({ ignoreSvgFill, theme }) =>
		css`
			svg {
				margin-right: 1.5rem;
				${!ignoreSvgFill &&
				css`
					path {
						fill: ${theme.colors.grayLighter3};
					}
				`}
			}
		`}
`;

export const Button = ({ children, ...rest }) => <StyledButton {...rest}>{children}</StyledButton>;

export const IconButton = styled.button`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 4rem;
	height: 4rem;
	background: transparent;
	color: ${({ theme }) => theme.colors.textColor};
	box-shadow: 0px 7px 13px rgba(98, 98, 98, 0.1);
	cursor: pointer;
	transition: color 150ms;

	&:hover {
		color: ${({ theme }) => theme.colors.primary};

		svg g {
			fill: ${({ theme }) => theme.colors.primary};
		}
	}
`;

export default Button;
